import Model from './Model';

export default class Campaign extends Model {
    resource() {
        return 'campaign';
    }


    // create new campaign
    storeCampaign(data) {
        return this.request({
            url: `${this.resource()}`,
            method: 'post',
            data: {
                name: data.name,
                method: data.method,
                campaign_tags: data.campaign_tags,
                emailscheduled: data.emailscheduled, // = savedraft
            }
        });
    }


    // create new campaign
    cloneCampaign(data) {
        return this.request({
            url: `${this.resource()}`,
            method: 'post',
            data: {
                name: data.name,
                method: data.method,
                campaign_tags: data.campaign_tags,
                emailscheduled: data.emailscheduled, // = savedraft

                emailtype: data.emailtype,
                email_id: data.email_id,
                template_id: data.template_id,
                gateway: data.gateway,
                sender_id: data.sender_id,
                sendername: data.sendername,
                senderemail: data.senderemail,
                conditions: data.conditions,
                subject: data.subject,
                previewtext: data.previewtext,
                editor_type: data.editor_type,
                message: data.message,
                emailContentSections: data.emailContentSections,
                sheduledtime: data.sheduledtime,
            }
        });
    }

    // update campaign
    updateCampaign(id, data) {
        return this.request({
            url: `${this.resource()}/${id}`,
            method: 'put',
            data: {
                name: data.name,
                method: data.sendoption,
                campaign_tags: data.campaign_tags,
                emailscheduled: data.emailscheduled,

                emailtype: data.emailbroadcasttype || 'singleemail',
                // description: data.description,
                gateway: data.emailgateway,
                sender_id: data.sender_id,
                sendername: data.sendername,
                senderemail: data.senderemail,
                conditions: data.subscribeoption,
                subject: data.emailsubject,
                previewtext: data.emailpreviewtext,
                editor_type: data.editor_type,
                message: data.sendoption === 'email' ? data.emailcontent : data.smscontent,
                emailContentSections: data.emailContentSections,
                sheduledtime: data.sheduledtime,

                postal_sequence_id: data.postal_sequence_id,
                email_id: data.email_id,
                actualdate: data.actualdate,
            }
        });
    }


    // Stop Campaigne
    campaignStop(id) {
        return this.request({
            url: `/stop/campaign`,
            method: 'post',
            data: {
                campaign_id: id,
            }
        });
    }

    // Archive Campaigne
    campaignArchive(id) {
        return this.request({
            url: `${this.resource()}/${id}`,
            method: 'delete',
            data: {
                campaign_id: id,
            }
        });
    }

    // Delete Campaigne
    campaignDelete(id) {
        return this.request({
            url: `/delete/campaign`,
            method: 'post',
            data: {
                campaign_id: id,
            }
        });
    }
}
